module.exports = __webpack_public_path__ + "img/60063.a5228bd9.png";